import { render } from "./TemplateDetail.vue?vue&type=template&id=43428f42&scoped=true&ts=true"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts"

import "./TemplateDetail.vue?vue&type=style&index=0&id=43428f42&scoped=true&lang=css"

import exportComponent from "/usr/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.0.11_vue@3.2.47_webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43428f42"]])

export default __exports__